export default function generateContractOptions(contracts = [], parentAccount) {
  return contracts
    .filter((c) => c.parent_account === parentAccount)
    .map((c) => ({
      value: c._id,
      label: c.name,
    }));
}
